import { ActionTypes as types } from '../constants'

export function changeUnilateralName(name) {
  return {
    type: types.UNILATERAL.CHANGE_UNILATERAL_NAME,
    data: { name },
  }
}

export function changeUnilateralCountryCode(countryCode) {
  return {
    type: types.UNILATERAL.CHANGE_UNILATERAL_COUNTRY_CODE,
    data: { countryCode },
  }
}
